import React, { useState, useEffect } from 'react'
import CountUp, { useCountUp } from "react-countup";
import axios from "axios";
import { BaseUrl } from "../../helper/BaseUrl";

const splitValue = (value = "") => {
    const match = value.toString().trim().match(/^([\d.,]+)(.*)$/);
    return {
        number: match ? Number(match[1].replace(/,/g, "")) : 0,
        suffix: match?.[2] || "",
    };
};

export default function HomeCounter({initialData}) {
    const [isClient, setIsClient] = useState(false);
    const [homeStats, sethomeStats] = useState(initialData || []);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useCountUp({
        ref: "counter",
        start: 0,
        end: 1234567,
        delay: 1000,
        duration: 3000,
    });

    
    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/home-our-stat/edit`);
            sethomeStats(response.data.Home_our_stat);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    if (!homeStats) {
        return null;
    }

    const firstCounters = [
        { count: homeStats.count1, text: homeStats.description1 },
        { count: homeStats.count2, text: homeStats.description2 },
    ];

    const secondCounters = [
        { count: homeStats.count3, text: homeStats.description3 },
        { count: homeStats.count4, text: homeStats.description4 },
        { count: homeStats.count5, text: homeStats.description5 },
        { count: homeStats.count6, text: homeStats.description6 },
    ];

  return (
    <>
    <section className="home-counter">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="counter-first">
                        <span className="counter-head heading">Measured by result</span>
                        {firstCounters.map((item, index) => { const { number, suffix } = splitValue(item.count);
                            return (
                                <div className="item-number" key={index}>
                                    <div className="num">
                                        {isClient ? (
                                            <CountUp key={`first-${number}`} end={number} duration={2} enableScrollSpy/>
                                        ) : (
                                            <span>{number}</span>
                                        )}
                                        <span>{suffix}</span>
                                    </div>
                                    <p>{item.text}</p>
                                </div>
                            );
                        })}
                    </div>   

                    <div className="counter-number">
                        {secondCounters.map((item, index) => { const { number, suffix } = splitValue(item.count);
                            return (
                                <div className="item-number" key={index}>
                                    {/* <div className="num">
                                        <CountUp end={number} enableScrollSpy redraw/>
                                        <span>{suffix}</span>
                                    </div> */}
                                    <div className="num">
                                        {isClient ? (
                                            <CountUp key={`second-${number}`} end={number} duration={2} enableScrollSpy/>
                                        ) : (
                                            <span>{number}</span>
                                        )}
                                        <span>{suffix}</span>
                                    </div>
                                    <p>{item.text}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
